import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const SendEsignConfirmationModalUI = ({
  context,
  isOpen,
  onCancel,
  onConfirm,
  esignSubmitted,
  successMsg,
  errorList,
  setErrorList
}) => (
  <ModalFormUI
    context={context}
    titleLabel='Confirm eSigning'
    buttonLabel='Send for eSigning'
    cancelLabel='Cancel'
    isOpen={isOpen}
    onRequestClose={onCancel}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onConfirm}
    busy={esignSubmitted}
  >
    <p className='g_m_top_25'>
      If you updated any token values after your last download, please click &quot;View document&quot; to regenerate the latest version before sending it for signing.
    </p>
  </ModalFormUI>
)

export default SendEsignConfirmationModalUI

